<script setup lang="ts">
import { computed } from 'vue';
import OverflowTooltip from '@/components/OverflowTooltip.vue';
import { booleanCellDisplayString } from '@/utils/booleanDisplay';

const props = defineProps<{
  field: string;
  dataType: string;
  data: any;
}>();

/**
 * Booleans read as "Yes" / "No", never `true` / `false`, and a nullable flag
 * with no value recorded reads as an em dash — NOT a blank cell, which in a
 * Yes/No column is easily misread as "No". Other types keep rendering empty as
 * a blank: only for a yes/no field is a blank actively misleading.
 */
const displayValue = computed(() => {
  const rawValue = props.data?.[props.field];
  if (props.dataType === 'boolean' || typeof rawValue === 'boolean') {
    return booleanCellDisplayString(rawValue);
  }
  return rawValue;
});
</script>

<template>
  <OverflowTooltip :deps="displayValue">{{ displayValue }}</OverflowTooltip>
</template>
